<template>
    <div class="orderhistory-container">
        <h3>Ordrehistorikk</h3>
        <div>
            <transition name="fade" mode="out-in">
                <div class="table" :key="currentPage">
                    <div class="row row-headers">
                        <div class="cell">Ordredato</div>
                        <div class="cell">OrdreID</div>
                        <div class="cell">Avdeling</div>
                        <div class="cell betalingsmetode">Betalingsmetode</div>
                        <div class="cell">Total</div>
                    </div>
  
                    <div class="row"
                        v-for="order in currentPageOrders"
                        :key="order.OrdreID">

                        <div class="cell">{{ order.Ordredato }}</div>
                        <div class="cell">{{ order.OrdreID }}</div>
                        <div class="cell">{{ order.Avdeling }}</div>
                        <div class="cell">{{ order.Betalingsmetode }}</div>
                        <div class="cell">{{ order.Total }}</div>
                    </div>

                    <div v-for="i in placeholders" :key="i" class="placeholder row">
                        <div class="cell cell-placeholder">Ingen data</div>
                    </div>
                </div>
            </transition>
        </div>
  
        <div class="btn-fixed">
            <button class="pagination-btn"
                @click="prevPage"
                :disabled="currentPage === 1">
                <a-icon type="left-circle" :style="{ fontSize: '35px' }" />
            </button>
            <span>Side {{ currentPage }} av {{ totalPages }}</span>
            <button class="pagination-btn"
                @click="nextPage"
                :disabled="currentPage === totalPages">
                <a-icon type="right-circle" :style="{ fontSize: '35px' }" />
            </button>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            currentPage: 1,
            ordersPerPage: 7,
            orders: [
            {
            Ordredato: "22.05.2023",
            OrdreID: 134534534535,
            Avdeling: "Jessheim",
            Betalingsmetode: "Credit Card",
            Total: "100 kr"
          },
          {
            Ordredato: "12.06.2023",
            OrdreID: 2345345345341,
            Avdeling: "Drammen",
            Betalingsmetode: "Debit Card",
            Total: "200 kr"
          },
          {
            Ordredato: "12.06.2023",
            OrdreID: 2345345345342,
            Avdeling: "Drammen",
            Betalingsmetode: "Debit Card",
            Total: "200 kr"
          },
          {
            Ordredato: "12.06.2023",
            OrdreID: 2345345345343,
            Avdeling: "Drammen",
            Betalingsmetode: "Debit Card",
            Total: "200 kr"
          },
          {
            Ordredato: "12.06.2023",
            OrdreID: 2345345345347,
            Avdeling: "Drammen",
            Betalingsmetode: "Debit Card",
            Total: "200 kr"
          },
          {
            Ordredato: "12.06.2023",
            OrdreID: 2345345345348,
            Avdeling: "Drammen",
            Betalingsmetode: "Debit Card",
            Total: "200 kr"
          },
          {
            Ordredato: "12.06.2023",
            OrdreID: 2345345345349,
            Avdeling: "Drammen",
            Betalingsmetode: "Debit Card",
            Total: "200 kr"
          },
          {
            Ordredato: "12.06.2023",
            OrdreID: 2345345345321,
            Avdeling: "Drammen",
            Betalingsmetode: "Debit Card",
            Total: "200 kr"
          }
        ]
      };
    },
  
    computed: {
        totalPages() {
            return Math.ceil(this.orders.length / this.ordersPerPage);
        },
        currentPageOrders() {
            const start = (this.currentPage - 1) * this.ordersPerPage;
            const end = start + this.ordersPerPage;
            return this.orders.slice(start, end);
        },
        placeholders() {
            const placeholdersNeeded = 7 - this.currentPageOrders.length;
            return placeholdersNeeded > 0 ? Array(placeholdersNeeded).fill(0) : [];
        }
    },
    methods: {
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
            }
        },
        prevPage() {
            if (this.currentPage > 1) {
            this.currentPage--;
        }
      }
    }
};
</script>
<style lang="scss" scoped>
  $desktop: 1200px;
  $laptop: 1024px;
  $tablet: 768px;
  $mobile: 480px;
  .cell-placeholder {
    text-align: center;
    font-weight: bold;
    color: darkgrey;
  }
  .btn-fixed {
    position: absolute;
    bottom: 7px; /* adjust as needed */
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 20px;
  }
  .pagination-btn {
    margin-left: 5px;
    background-color: transparent;
  }
  
  .pagination-btn:disabled {
    opacity: 0.5;
  }
  .orderhistory-container {
    position: relative;
    padding-bottom: 4rem;
  }
  .row-headers {
    font-weight: bolder;
  }
  .table {
    display: flex;
    flex-direction: column;
  }
  
  .row {
    display: flex;
    margin-bottom: 10px; /* gap between rows */
    border: 1px solid;
    border-radius: 10px;
    overflow: hidden;
    background: white;
    transition: transform 0.3s ease-in-out;
    &:hover {
      transform: scale(1.03);
    }
  }
  
  .cell {
    flex: 1 0 0;
  
    padding: 10px;
    border: 1px solid #ddd;
  }
  
  .betalingsmetode {
    width: 25rem;
  }
  </style>
  